import { store } from '@/store';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default {

    connect() {
        if (!store.getters.apiKey) return;
        window.Pusher = Pusher;
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.VUE_APP_PUSHER_KEY,
            cluster: process.env.VUE_APP_PUSHER_CLUSTER,
            useTLS: true,
            authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
            auth: {
                headers: {
                    'Authorization': `Bearer ${store.getters.apiKey}`,
                },
            },
        });
    },

    leave(channel) {
        if (window.Echo) {
            window.Echo.leave(channel);
        }
    },

    disconnect() {
        if (window.Echo) {
            window.Echo.disconnect();
        }
    },

}